/**
 * ErrorDisplay Component
 * Voor als het misgaat (oeps)
 */

import React from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {useTranslation} from 'react-i18next';

interface ErrorDisplayProps {
  message?: string;
  title?: string;
  onRetry?: () => void;
  showRetry?: boolean;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  message,
  title,
  onRetry,
  showRetry = true,
}) => {
  const {t} = useTranslation();

  return (
    <View style={stijlen.container}>
      <Text style={stijlen.icon}>⚠️</Text>
      <Text style={stijlen.title}>{title || t('common.error') || 'Fout'}</Text>
      <Text style={stijlen.message}>{message || t('errors.unknownError') || 'Er is iets misgegaan'}</Text>
      {showRetry && onRetry && (
        <TouchableOpacity style={stijlen.retryButton} onPress={onRetry}>
          <Text style={stijlen.retryButtonText}>{t('common.retry') || 'Opnieuw'}</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

const stijlen = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  icon: {
    fontSize: 48,
    marginBottom: 16,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 8,
  },
  message: {
    fontSize: 16,
    color: '#666',
    textAlign: 'center',
    marginBottom: 24,
    lineHeight: 24,
  },
  retryButton: {
    backgroundColor: '#4A90E2',
    paddingHorizontal: 32,
    paddingVertical: 12,
    borderRadius: 24,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  retryButtonText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
});

export default ErrorDisplay;
